module.exports = __webpack_public_path__ + "static/media/ram_doc3.a5180305.jpg";